import React from "react";
import { createPDF } from "../utils/generatePDF";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

const Breadcrumbs = ({ crumbs, modulo }) => {
  let depth = crumbs.length - 1;
  return (
    <div className="bg-light p-2 breadcrumbs mb-5 d-flex justify-content-between">
      <div>
        {" "}
        {crumbs.map((c, idx) => (
          <span key={idx}>
            <a href={c.url}>{c.title}</a>
            {idx < depth ? " > " : ""}
          </span>
        ))}
      </div>
      <div>
        {modulo && (
          <div
            className={`download-btn c-${modulo.color}`}
            onClick={() => createPDF(modulo.title)}
          >
            Descargar <FontAwesomeIcon icon={faDownload} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Breadcrumbs;
